module.exports = __webpack_public_path__ + "assets/img/profile.dbcb559c.svg";